<ev-dialog
    [visible]="visible()"
    (close)="closeDialog()"
    [disabledConfirm]="!validInput"
    (confirm)="confirmVerification()"
    [theme]="'green'"
    [maxWidth]="'460px'"
    [title]="title()"
>
    @if (visible()) {
        <div class="verification-dialog">
            <div class="verification-wrapper">
                <div class="verification-header">
                    <div class="title">
                        @if (appraisalValues().valueHistoryType === valueHistoryType.CommercialAppraisalBank) {
                            Ikke bruk næringstakst
                        } @else if (appraisalValues().valueHistoryType === valueHistoryType.PreAppraisalBank) {
                            Ikke bruk evForhåndstakst
                        } @else {
                            Ikke bruk etakst/takst
                        }
                    </div>
                    <div>
                        <ev-toggle
                            [active]="verificationApprovalEnum === appraisalDialogApprovalStatus.Avvist"
                            [style]="ToggleStyle.NEGATIVE"
                            (change)="changeDenyAppraisal()"
                            [size]="20"
                        ></ev-toggle>
                    </div>
                </div>
                @if (appraisalValues().valueHistoryType !== valueHistoryType.CommercialAppraisalBank) {
                    <div class="verification-body">
                        @if(appraisalValues().valueHistoryType === valueHistoryType.PreAppraisalBank) {
                            Elementer ved evForhåndstaksten gjør at ditt selskap ikke skal legge denne verdien til grunn ved lånebevilgning.
                        } @else {
                        Elementer ved etaksten/taksten gjør at ditt selskap ikke skal legge denne verdien til grunn ved lånebevilgning.
                        }
                        @if (verificationApprovalEnum === appraisalDialogApprovalStatus.Avvist) {
                            <div class="inputform">
                                <div class="title">
                                    Begrunnelse for ikke bruk
                                    <div class="dot"></div>
                                </div>
                                <ev-dropdown-reactive
                                    [height]="'32'"
                                    [items]="dropDownItems()"
                                    (onChange)="chooseDeniedReason($event)"
                                    class="denied-dropdown"
                                >
                                </ev-dropdown-reactive>
                                @if (appraisalDeniedReason === null) {
                                    <textarea rows="2" #verificationComment (keyup)="onKey(verificationComment.value)"></textarea>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="verification-wrapper">
                <div class="verification-header">
                    <div class="title">
                        @if (appraisalValues().valueHistoryType === valueHistoryType.CommercialAppraisalBank) {
                            Bruk næringstakst
                        } @else if (appraisalValues().valueHistoryType === valueHistoryType.PreAppraisalBank) {
                            Bruk evForhåndstakst
                        } @else {
                            Bruk etakst/takst
                        }
                    </div>
                    <div>
                        <ev-toggle
                            [active]="verificationApprovalEnum === appraisalDialogApprovalStatus.Godkjent"
                            [style]="ToggleStyle.CHECK"
                            (change)="changeAcceptAppraisal()"
                            [size]="20"
                        ></ev-toggle>
                    </div>
                </div>
                @if (
                    appraisalValues().valueHistoryType !== valueHistoryType.CommercialAppraisalBank
                ) {
                    <div class="verification-body">
                        @if(appraisalValues().valueHistoryType === valueHistoryType.PreAppraisalBank) {
                            Denne evForhåndstaksten vil, for ditt selskap, legges til grunn ved lånebevilgning.
                        }
                        @if(appraisalValues().valueHistoryType !== valueHistoryType.PreAppraisalBank) {
                            Denne etaksten/taksten vil, for ditt selskap, legges til grunn ved lånebevilgning.                         
                            Opplysningene vil også kunne benyttes dersom ditt
                            selskap senere innhenter et evEstimat.
                        }
                    </div>
                }
            </div>

            <div class="report-signing">
                <div class="title">
                    Signatur
                    <div class="dot"></div>
                </div>
                <ev-input-reactive [variant]="'grey'" [value]="signature" [blurOnKeyEnter]="true" (keyUp)="onSigningKey($event)" (blur)="onSigningKey($event)"></ev-input-reactive>
            </div>
            <div class="verification-history">
                <infopage-accordion [accordionState]="appraisalHistoryAccordionState">
                    <div class="accordion-content content-wrapper">
                        @for (item of appraisalHistory(); track item) {
                            <div class="report">
                                <div class="report-header">
                                    <div class="report-icon" [class]="{approved: item.appraisalReportApprovalStatus === reportApprovalStatus.Approved, rejected: item.appraisalReportApprovalStatus === reportApprovalStatus.Rejected}"></div>
                                    <div class="report-id">{{ item.signature }}</div>
                                    <div class="flex-grow"></div>
                                    <div class="report-date">{{ item.createdDate | date : "shortDate" | defaultconvert : "-" }}</div>
                                    <div class="report-status">{{ reportApprovalStatus[item.appraisalReportApprovalStatus] }}</div>
                                </div>
                                @if (item.appraisalDeniedReason) {
                                    <div class="report-body">
                                        {{ getAppraisalDeniedDescription(item.appraisalDeniedReason) }}
                                    </div>
                                } @else if (item.comment) {
                                    <div class="report-body">
                                        {{ item.comment }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </infopage-accordion>
            </div>
        </div>
    }
</ev-dialog>
